/*
===============================================================================================================
                                 Copyright 2022-2024, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { toWebSafeFormat } from '@/utilities/strings';
import ToggleSwitch from '../toggle-switch';

export default function ToggleGroup({
  inputSelectorId,
  items,
  onChange,
  ariaLabel,
}) {
  const [itemsList, setItemsList] = useState([]);

  useEffect(() => {
    if (items) {
      const newList = [...items];
      setItemsList(newList);
    }
  }, [items]);

  const onToggleChange = (index) => {
    const newList = [...itemsList];
    newList[index].value = !newList[index].value;
    setItemsList(newList);
    onChange(newList);
  };

  return (
    <>
      <div className="toggle-group-wrapper" id={inputSelectorId}>
        {itemsList.map((item, idx) => (
          <ToggleSwitch
            ariaLabel={`${ariaLabel} ${item.label}`}
            key={item.label}
            inputSelectorId={`toggle-switch-${toWebSafeFormat(item.label)}`}
            onChange={() => onToggleChange(idx)}
            label={item.label}
            defaultValue={item.value}
          />
        ))}
      </div>
      <style jsx>
        {`

          .toggle-group-wrapper {
            display: flex;
            flex-direction: column;
            gap: 20px;
            padding-top: 8px;
            width: 100%;
          }
        `}
      </style>
    </>
  );
}

ToggleGroup.defaultProps = {
  inputSelectorId: null,
  onChange: null,
  ariaLabel: null,
};

ToggleGroup.propTypes = {
  inputSelectorId: PropTypes.string,
  onChange: PropTypes.func,
  ariaLabel: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.bool.isRequired,
  })).isRequired,
};
